import React from 'react'
import styled from 'styled-components'
// import { positionXForLines, positionXForLinesRange } from './utils'

const ValueWrapper = styled.div`
    border-radius: 3px;
    border: 1px solid #37a3ef;
    height: 100%;
    background-color: var(--gray-0);
`

const H2Styled = styled.h2`
    margin: auto;
    margin-top: 8px;
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    color: var(--gray-900);
    text-align: center;
`

const H3Styled = styled.h3`
    margin: auto;
    margin-top: 4px;
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    color: var(--gray-900);
    text-align: center;
`

const ValueStyled = styled.p`
    margin: auto;
    margin-top: 4px;
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: var(--gray-800);
    text-align: center;
`

const ValueStyledP2 = styled.p`
    margin: auto;
    margin-top: 4px;
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    opacity: 0.85;
    line-height: 12px;
    color: var(--gray-800);
    text-align: center;
`

const Divider = styled.div`
    width: 66px;
    height: 1px;
    margin: auto;
    margin-top: 2px;
    border-bottom: 1px solid var(--gray-700);
    /* border-bottom: 1px solid #606a80; */
`
// const boxXSize = (points: string, size, x = '59', numberOfSections, range, lithology): string | number => {
//     const x_md = range?.length > 0 ? (lithology ? positionXForLinesRange(numberOfSections) + numberOfSections * 8 : Number(x) - 2) : (positionXForLines(numberOfSections) + numberOfSections * 8)
//     return size == 'md' ? x_md.toString() : x.toString()
// }

const WrapperBox = ({
    points,
    className,
    y,
    height,
    children,
    x,
    size = 'lg',
    numberOfSections,
    range = [],
    lithology
}: {
    points: string
    className?: string
    height: number | string
    y: number | string
    children?: any
    x?: string
    size?: 'sm' | 'md' | 'lg'
    numberOfSections: number
    range: Array<number>
    lithology: boolean
}) => {
    if (size === 'sm') return <g></g>
    return (
        <>
            {size !== 'sm' && range?.length > 0 && (
                <>
                    <polyline
                        points={points}
                        fill="none"
                        markerStart="url(#blue-circle)"
                        className={className + ' conectors-to-box-white'}
                    />
                    <polyline
                        points={points}
                        fill="none"
                        markerStart="url(#blue-circle)"
                        className={className + ' conectors-to-box-blue'}
                    />
                </>
            )}

            <foreignObject
                x={x} //boxXSize(points, size, x, numberOfSections, range, lithology)}
                y={y}
                width='82'
                height={height}
            >
                <ValueWrapper>{children}</ValueWrapper>
            </foreignObject>
        </>
    )
}

export const ValueBox = (props: {
    points: string
    className?: string
    height: number | string
    y: number | string
    children?: any
    theme: string
    h2: string
    p: number | string
    p2?: number | string
    x?: string
    directionDown?: boolean
    size?: 'sm' | 'md' | 'lg'
    numberOfSections: number
    range: Array<number>
    lithology: boolean
}) => (
    <WrapperBox {...props}>
        <H2Styled theme={props.theme}>{props.h2}</H2Styled>
        {props.p2 && props.directionDown && props.p2 !== '- ' && (
            <ValueStyledP2 theme={props.theme}>Prev: {props.p2}</ValueStyledP2>
        )}
        <ValueStyled theme={props.theme}>{props.p}</ValueStyled>
        {props.p2 && !props.directionDown && props.p2 !== '- ' && (
            <ValueStyledP2 theme={props.theme}>Prev: {props.p2}</ValueStyledP2>
        )}
    </WrapperBox>
)

export const MainValueBox = (props: {
    points: string
    className?: string
    height: number | string
    y: number | string
    children?: any
    theme: string
    h2: string
    h3_1: string
    p_1: number | string
    h3_2: string
    p_2: number | string
    x?: string
    range: Array<number>
    lithology: boolean
}) => (
    <WrapperBox {...props}>
        <H2Styled theme={props.theme}>{props.h2}</H2Styled>
        <Divider />
        <H3Styled theme={props.theme}>{props.h3_1}</H3Styled>
        <ValueStyled theme={props.theme}>{props.p_1}</ValueStyled>
        <H3Styled theme={props.theme}>{props.h3_2}</H3Styled>
        <ValueStyled theme={props.theme}>{props.p_2}</ValueStyled>
    </WrapperBox>
)
